import React, { useEffect, useState } from "react";
import TableCustom from "../../../components/table/tableCustom";
import TableRowCommon from "../../../components/table/TableRowCommon";
import { NavigateFunction, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { dateTimeToView } from "../../../utils/date.utils";
import { routeName } from "../../../routes/routeName";
import { icons } from "../../../assets/icons/icons";
import DropdownButton from "../../../components/button/DropdownButton";
import { Button, MenuItem } from "@mui/material";
import FilterSelect from "../../../components/select/filterSelect";
import moment from "moment";
import InputTextField from "../../../components/input/inputTextField";
import { FiberManualRecord, SearchOutlined } from "@mui/icons-material";
import InputNewRangePicker from "../../../components/input/inputRankPicker";
import { ButtonPrimary } from "../../../components/button/ButtonCustoms";
import { advisorStudentApi } from "../../../api/advisor-student/advisor-student.api";
import CustomStatus from "../../../components/chip/CustomStatus";
import {
  allStatusConsultRequestUtil,
  handleColorStatusConsultRequestUtil,
  handleTextStatusConsultRequestUtil,
} from "../../../utils/statusRequest";
import { dataEvaluation } from "../../../utils/usage_form_evluation";
import { advisorTypeApi } from "../../../api/advisor-type/advisor-type.api";
import ContentHeading from "../../../components/layout/content/ContentHeading";
import { ReportApi } from "../../../api/report/Report.api";
import { getFileExtension } from "../../../utils/fileTypeDownload";
import { saveAs } from "file-saver";
import { setLoading, unsetLoading } from "../../../store/loading/loading.slice";
import { colors } from "../../../constants/colors";

const ReportConsultationRequest = () => {
  const navigate: NavigateFunction = useNavigate();
  const dispatch = useDispatch();

  const { profile } = useSelector((state: any) => state.profile);

  const [dataAdvisor, setDataAdvisor] = useState<any[]>([]);
  const [dataAdvisorType, setDataAdvisorType] = useState<any[]>([]);

  const [inputValueSearch, setInputValueSearch] = useState({
    keyword: "",
    consultation_type: "",
    advisor_group: "",
    status: "",
  });

  const [page, setPage] = useState<number>(1);
  const [pageLimit, setPageLimit] = useState<number>(10);
  const [totalItems, setTotalItems] = useState<number>(0);
  const [sortBy, setSortBy] = useState<string>("");
  const [sortType, setSortType] = useState<string>("ASC");

  const [startDate, setStartDate] = useState<string>("");
  const [endDate, setEndDate] = useState<string>("");
  const [selectedDateRange, setSelectedDateRange] = useState<string[]>([]);
  const handleRangeDate = (value: any) => {
    setSelectedDateRange(value);
    setStartDate(moment(value[0]).format("YYYY-MM-DD"));
    setEndDate(moment(value[1]).format("YYYY-MM-DD"));
  };

  const handleClearRangeDate = () => {
    setSelectedDateRange([]);
    setStartDate("");
    setEndDate("");
  };

  const getAdvisorType = async () => {
    let query: any = {
      page: 1,
      limit: 100000,
    };

    const res = await advisorTypeApi.getAllAdvisorType(query);

    const data = res.data;
    if (data.status < 300) {
      setDataAdvisorType(data.data.items);
    } else {
      setDataAdvisorType([]);
    }
  };

  useEffect(() => {
    getAdvisorType();
  }, []);

  const headCells = [
    {
      id: "fullname",
      width: 50,
      disablePadding: true,
      align: "start",
      label: "ชื่อ - นามสกุล นักศึกษา",
    },
    {
      id: "nickname",
      width: 50,
      disablePadding: true,
      align: "start",
      label: "ฉายา",
    },
    {
      id: "employee_no",
      width: 50,
      disablePadding: true,
      align: "center",
      label: "รหัสประจำตัวนักศึกษา",
    },
    {
      id: "request_title",
      width: 50,
      disablePadding: true,
      align: "center",
      label: "เรื่องที่ขอคำปรึกษา",
    },
    {
      id: "advisor_type",
      disablePadding: false,
      align: "center",
      width: 15,
      label: "ประเภทอาจารย์ที่ปรึกษา",
    },
    {
      id: "advisor_name",
      disablePadding: true,
      width: 15,
      align: "center",
      label: "ชื่อ - นามสกุล อาจารย์",
    },
    {
      id: "advisor_no",
      disablePadding: false,
      align: "center",
      width: 50,
      label: "เลขประจำตัวอาจารย์",
    },
    {
      id: "request_date",
      disablePadding: false,
      align: "center",
      width: 20,
      label: "วันที่ขอคำปรึกษา",
    },
    {
      id: "status",
      disablePadding: false,
      align: "center",
      width: 20,
      label: "สถานะ",
    },
    {
      id: "action",
      disablePadding: false,
      align: "center",
      width: 20,
      label: "action",
    },
  ];

  const renderData = (objData: any, no: any) => {
    no = page * pageLimit - pageLimit + no + 1;
    const {
      id_advisor_student,
      id_advisor,
      student_no,
      student_title,
      student_first_name,
      student_last_name,
      student_nickname,
      first_name_advisor,
      last_name_advisor,
      first_name_class_emp,
      last_name_class_emp,
      employee_no,
      first_name_emp,
      last_name_emp,
      advisor_group,
      advisor_student_detaill,
      created_date,
      grade_level,
      faculty_name
    } = objData;

    let parsedAdvisorStudentDetail = [];

    try {
      parsedAdvisorStudentDetail = JSON.parse(advisor_student_detaill);
    } catch (error) {
      console.error("Error parsing advisor_student_detaill:", error);
    }

    const objRenderData = {
      key: id_advisor_student,
      id: no,
      obj: objData,
      columns: [
        {
          option: "TEXT",
          align: "start",
          label: student_first_name + " " + student_last_name,
        },
        {
          option: "TEXT",
          align: "start",
          label: student_nickname,
        },
        {
          option: "TEXT",
          align: "center",
          label: student_no ?? "-",
        },
        {
          option: "TEXT",
          align: "center",
          disablePadding: true,
          label: parsedAdvisorStudentDetail?.advisor_type_name ?? "-",
        },
        {
          option: "TEXT",
          align: "center",
          disablePadding: true,
          label: advisor_group ?? "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: first_name_advisor + " " + last_name_advisor,
        },
        {
          option: "TEXT",
          align: "center",
          label: employee_no ?? "-",
        },
        {
          option: "TEXT",
          align: "center",
          disablePadding: true,
          label: created_date ? dateTimeToView(created_date) : created_date,
        },
        {
          option: "TEXT",
          align: "center",
          // label: parsedAdvisorStudentDetail?.status ?? "-",
          label: (
            <CustomStatus
              label={handleColorStatusConsultRequestUtil(
                parsedAdvisorStudentDetail?.status,
                profile && profile.user_type
              )}
              type="outlined"
              color={handleTextStatusConsultRequestUtil(
                parsedAdvisorStudentDetail?.status
              )}
              icon={<FiberManualRecord />}
              width="250px"
            />
          ),
        },
        {
          option: "TEXT",
          align: "center",
          label: (
            <div
              style={{
                display: "flex",
                textAlign: "center",
                justifyContent: "center",
              }}
            >
              <img
                onClick={() => {
                  navigate(
                    routeName.cms.consultingReport + `/${id_advisor_student}?grade_level=${grade_level}&faculty_name=${faculty_name}`
                  );
                }}
                src={icons.eye}
                alt="eye"
                style={{ cursor: "pointer" }}
              />
            </div>
          ),
        },
      ],
    };
    return <TableRowCommon {...objRenderData} />;
  };

  const handleChangeValueSearch = (name: string, value: any) => {
    setInputValueSearch((prev: any) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const getDataConsultationRequest = async () => {
    let query: any = {
      page: page,
      limit: pageLimit,
      sortBy: sortBy,
      sortType: sortType,
      status: inputValueSearch.status,
      sdate: startDate,
      edate: endDate,
      advisor_group: inputValueSearch.advisor_group,
      advisorTypeId:
      inputValueSearch.consultation_type === "ทุกเรื่องที่ขอคำปรึกษา"
        ? ""
        : inputValueSearch.consultation_type,
    };

    const res = await advisorStudentApi.reportListEmployee(query);
    const data = res.data;
    if (data.status < 300) {
      setDataAdvisor(data.data.items);
      setTotalItems(res.data?.data?.meta?.totalItems || 0);
    } else {
      setDataAdvisor([]);
    }
  };

  useEffect(() => {
    getDataConsultationRequest();
  }, [page, pageLimit, sortBy, sortType, inputValueSearch, startDate, endDate]);

  const handleDownloadFile = async (type: string) => {
    dispatch(setLoading());

    let query: any = {
      type: type,
    };

    await ReportApi.downloadReportAdvisorstudent(query)
      .then((res) => {
        if (res.status < 300) {
          const response = res.data;

          // Get the content type from the server's response headers
          const contentType = res.headers["content-type"];

          // Create a Blob with the content type from the response
          const blob = new Blob([response], { type: contentType });

          // Extract file extension based on content type
          const fileExtension = getFileExtension(contentType || "");

          // Generate a filename with the correct extension (you can also modify this to use a custom name)
          const fileName = `${
            "report-advisor" + new Date().getTime()
          }.${fileExtension}`;

          // Save the file
          saveAs(blob, fileName);
        }
      })
      .catch((error) => console.log(error))
      .finally(() => dispatch(unsetLoading()));
  };

  return (
    <>
      <ContentHeading
        title={"รายงานการให้คำปรึกษา"}
        detail="กรุณาเลือกรายการที่ท่านต้องการ"
      />

      <div className="w-full grid grid-cols-12 gap-4 mt-[40px]">
        <article className="w-full col-span-12 lg:col-span-3 md:col-span-3 sm:col-span-12">
          <InputNewRangePicker
            value={selectedDateRange}
            onchange={handleRangeDate}
            onClear={handleClearRangeDate}
            allowClear
          />
        </article>

        <article className="w-full col-span-12 lg:col-span-2 md:col-span-3 sm:col-span-12">
          <FilterSelect
            value={inputValueSearch.consultation_type ?? ""}
            labelId="consultation_type-id"
            selectId="consultation_type-select-id"
            options={[
              {
                id_consultation_type: "",
                consultation_type_name: "ทุกเรื่องที่ขอคำปรึกษา",
              },
              ...dataAdvisorType.map((item, index) => ({
                id_consultation_type: item.id_advisor_typeid,
                consultation_type_name: item.advisor_type_name,
              })),
            ].map((list, index) => (
              <MenuItem value={list.consultation_type_name} key={index + 1}>
                {list.consultation_type_name}
              </MenuItem>
            ))}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
              handleChangeValueSearch("consultation_type", e.target.value)
            }
          />
        </article>

        <article className="w-full col-span-12 lg:col-span-2 md:col-span-3 sm:col-span-12">
          <FilterSelect
            value={inputValueSearch.advisor_group ?? ""}
            labelId="advisor_group-id"
            selectId="advisor_group-select-id"
            options={[
              {
                id_advisor_group: "",
                advisor_group_name: "ทุกประเภทอาจารย์ที่ปรึกษา",
              },
              ...dataEvaluation.map((item, index) => ({
                id_advisor_group: item.id,
                advisor_group_name: item.name,
              })),
            ].map((list, index) => (
              <MenuItem value={list.id_advisor_group} key={index + 1}>
                {list.advisor_group_name}
              </MenuItem>
            ))}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
              handleChangeValueSearch("advisor_group", e.target.value)
            }
          />
        </article>

        <article className="w-full col-span-12 lg:col-span-2 md:col-span-3 sm:col-span-12">
          <FilterSelect
            value={inputValueSearch.status ?? ""}
            labelId="status-id"
            selectId="status-select-id"
            options={[
              {
                id_status: "",
                status_name: "ทุกสถานะ",
              },
              ...allStatusConsultRequestUtil.map((item) => ({
                id_status: item,
                status_name: handleColorStatusConsultRequestUtil(
                  item,
                  profile && profile.user_type
                ),
              })),
            ].map((list, index) => (
              <MenuItem value={list.id_status} key={index + 1}>
                {list.status_name}
              </MenuItem>
            ))}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
              handleChangeValueSearch("status", e.target.value)
            }
          />
        </article>

        <article
          className="w-full col-span-12 lg:col-span-3 md:col-span-4 sm:col-span-12"
          style={{
            display: "flex",
            justifyContent: "end",
          }}
        >
          <Button
            variant="outlined"
            sx={{
              backgroundColor: colors.success3,
              color: "white",
              border: colors.success3,
              "&:hover": {
                backgroundColor: colors.success3, // Retain the same background color
                borderColor: colors.success3, // Retain the same border color
              },
            }}
            startIcon={<img src={icons.icon_excel} alt="start-icon" />}
            onClick={() => {
              handleDownloadFile("xlsx");
            }}
          >
            ดาวน์โหลด Excel
          </Button>
        </article>
      </div>
      <section className="w-full mt-10">
        <TableCustom
          tableMinWidth={2000}
          tableFixedWidth
          customScroll
          page={page}
          pageLimit={pageLimit}
          sortBy={sortBy}
          sortType={sortType}
          headCells={headCells}
          rowCount={totalItems}
          rowsData={
            dataAdvisor &&
            dataAdvisor.map((data: any, i: any) => {
              return renderData(data, i);
            })
          }
          onSort={() => {}}
          setPageLimit={(value: number) => setPageLimit(value)}
          setPage={(value: number) => setPage(value)}
        />
      </section>
    </>
  );
};

export default ReportConsultationRequest;
